import React from 'react'

class ContactUsSuccess extends React.Component {
  render () {
    return (
        <div>
        <h3 style={{ color: 'blue' }}>Your inquiry has been submitted successfully</h3>
        <h4 style={{ color: 'blue' }}>If warranted, someone will contact you</h4>
        <h6 style={{ color: 'blue' }}>Thank you!</h6>
        <h6 style={{ color: 'blue' }}>Please keep in mind that sometimes it may take time to respond</h6>
        </div>
    )
  }
}
export default ContactUsSuccess;